(function () {
  if (!document.querySelector(".product.wd-product-template")) {
    return;
  }

  var getButtons = function () {
    return Array.from(
      document.querySelectorAll(
        ".product.wd-product-template [data-wd-atc-priced]",
      ),
    );
  };

  var getLabelText = function (button) {
    var label = button.querySelector(".product-add-to-cart__label");

    if (label && label.textContent.trim()) {
      return label.textContent.trim();
    }

    if (window.themeCore && window.themeCore.translations) {
      return window.themeCore.translations.get("products.product.add_to_cart");
    }

    return button.textContent.trim();
  };

  var getPriceText = function (button) {
    var juo = document.getElementById("juo-subscription-widget");

    if (juo) {
      var checked = juo.querySelector('input[name="juo-purchase-option"]:checked');
      var option = checked && checked.closest(".juo-option");
      var money = option && option.querySelector('[data-role="current-price"] .money');

      if (money && money.textContent.trim()) {
        return money.textContent.trim();
      }
    }

    var priceEl = button.querySelector(".js-wd-add-to-cart-price");

    if (priceEl) {
      var nestedMoney = priceEl.querySelector(".money");
      var priceFromEl = nestedMoney
        ? nestedMoney.textContent.trim()
        : priceEl.textContent.trim();

      if (priceFromEl) {
        return priceFromEl;
      }
    }

    return button.getAttribute("data-wd-atc-price") || "";
  };

  var syncButton = function (button) {
    if (!button) {
      return;
    }

    if (button.disabled) {
      return;
    }

    var priceText = getPriceText(button);

    if (!priceText) {
      var existingPrice = button.querySelector(".js-wd-add-to-cart-price");

      if (existingPrice && existingPrice.textContent.trim()) {
        return;
      }

      return;
    }

    var labelText = getLabelText(button);

    button.innerHTML =
      '<span class="product-add-to-cart__text"><span class="product-add-to-cart__label">' +
      labelText +
      '</span> - <span class="js-wd-add-to-cart-price">' +
      priceText +
      "</span></span>";
    button.setAttribute("data-wd-atc-price", priceText);
  };

  var syncAll = function () {
    getButtons().forEach(syncButton);
  };

  var observeButtons = function () {
    getButtons().forEach(function (button) {
      new MutationObserver(function () {
        var priceEl = button.querySelector(".js-wd-add-to-cart-price");

        if (!priceEl || !priceEl.textContent.trim()) {
          syncButton(button);
        }
      }).observe(button, { childList: true, subtree: true, characterData: true });
    });
  };

  var init = function () {
    syncAll();
    observeButtons();
  };

  var scheduleSync = function () {
    syncAll();
    window.setTimeout(syncAll, 0);
    window.setTimeout(syncAll, 100);
    window.setTimeout(syncAll, 300);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  window.addEventListener("load", scheduleSync);
  document.addEventListener("wd:atc-updated", scheduleSync);
  document.addEventListener("juo:price-updated", syncAll);
  document.addEventListener("change", function (event) {
    if (!event.target) {
      return;
    }

    if (
      event.target.name === "juo-purchase-option" ||
      event.target.matches('input[name="quantity"], [data-quantity-input]')
    ) {
      syncAll();
    }
  });

  var waitForTheme = function () {
    if (window.themeCore && window.themeCore.EventBus) {
      window.themeCore.EventBus.listen("product:loaded", scheduleSync);
      scheduleSync();
      return;
    }

    window.setTimeout(waitForTheme, 50);
  };

  waitForTheme();
})();
